import { Panel, PanelHeaderTemplateOptions } from "primereact/panel";
import { IGPS353 } from "../../../../interface/GPS353";
import "../styles.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import NadaConsta from "../../../../components/nadaConsta";
import { useTranslation } from "react-i18next";



export function Gps353(data: IGPS353) {
  const { t } = useTranslation();
  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {data?.["DEBITOS"] && data?.["DEBITOS"].length  > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('restricaoMercado')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('restricaoMercado')}</span>) }</div>;
  }
  return (
    <Panel headerTemplate={headerTemplate} toggleable>
        {data?.["DEBITOS"] && data?.["DEBITOS"].length > 0 ? (
          <DataTable value={data?.["DEBITOS"]}>
            <Column header="Ocorrência" field="DATAOCORRENCIA" />
            <Column header="Disponibilização" field="DATADISPONIBILIZACAO" />
            <Column header="Informante" field="INFORMANTE" />
            <Column header="Tipo Ocorrência" field="TIPOOCORRENCIA" />
            <Column header="Contrato" field="CONTRATO" />
            <Column header="Cidade" field="CIDADE" />
            <Column header="UF" field="UF" />
            <Column header="Situação" field="SITUACAO" />
            <Column header="Valor" field="VALOR" />
          </DataTable>
        ) : (
          <NadaConsta></NadaConsta>
        )}
      </Panel>
  );
}
